/**
 * Encapsulates a promise from the promiseFactory (the "inner promise") and validates the response with the validator function. If the validation fails or the promise is
 * rejected, a new inner promise is created after waiting for some time. This process is repeated until the maximum number of tries is reached or the inner promise resolves
 * and has a valid response.
 * 
 * @param promiseName A string that is used to identify this action in errors and warnings
 * @param promiseFactory A function that returns a promise
 * @param validator A function that takes the promise response and returns a boolean that indicates whether the response is valid
 * @param maxTries The number of times the operation is retried
 * @param waitTime The time to wait between operations
 * 
 * @returns A promise that resolves when the inner promise from the promise factory resolves and has a valid response, and rejects when the maximum number of tries is reached
 */
export const promiseValidResponse = ( promiseName: string, promiseFactory: () => Promise<any>, validator: (response:any) => boolean, maxTries: number = 20, waitTime: number = 2000 ) : Promise<any> => {
    const execute = ( promiseFactory: () => Promise<any>, validator: (response:any) => boolean, resolve: (response:any) => any, reject: (error:any) => void, maxTries: number, waitTime: number ) => {
        promiseFactory()
        .then( response => {
            if( containsException(response) ) {
                //throw new Error(promiseName+': Response contains an exception');
            }
            if( !validator(response) ) {
                //throw new Error(promiseName+': Response is invalid');
            }
            resolve(response);
        } )
        .catch(
            error => {
                if (__ENVIRONMENT__ === 'dev') {
                    console.error(error)
                }
                if( maxTries > 0 ) {
                    // TODO optimize this by examining the expiration header. If it's present, and higher than waitTime, use it instead.
                    setTimeout( () => execute(promiseFactory,validator,resolve,reject,maxTries-1,waitTime), waitTime );
                }
                else {
                    //reject(new Error(promiseName+': Maximum retries exceeded'));
                }
            }
        );
    }

    return new Promise<any>(
        ( resolve, reject ) => execute( promiseFactory, validator, resolve, reject, maxTries, waitTime )
    );
}

export const containsException = (data: any) : boolean => {
    if(data&&data.doc&&data.doc[0]&&data.doc[0].event == "exception") {
        return true;
    }
    return false;
};
